import { graphql } from '../../gql';

export const PAY_V2_QUERY = graphql(`
  query GetPayV2($req: PayV2Req) {
    pay_v2(req: $req) {
      entities {
        metadata {
          id
          short_name
          long_name
        }
        metrics {
          overtime {
            counts
            SalaryBase
            SalaryTotal
            SalaryHourly
          }
          histogram {
            index
            base
            total
            hourly
          }
          top_companies {
            index
            shortName
            longName
            base
            total
            hourly
          }
          top_geos {
            index
            shortName
            longName
            base
            total
            hourly
          }
          top_roles {
            index
            shortName
            longName
            base
            total
            hourly
          }
        }
      }
      refs {
        months
      }
    }
  }
`);

export const PAY_V2_TOOLTIP_QUERY = graphql(`
  query GetPayV2Tooltip($req: PayV2Req) {
    pay_v2(req: $req) {
      entities {
        metadata {
          id
          short_name
          long_name
        }
        metrics {
          histogram {
            index
            base
            total
            hourly
          }
        }
      }
      refs {
        months
      }
    }
  }
`);

export const PAY_V2_TOPGEOS_QUERY = graphql(`
  query GetPayV2TopGeos($req: PayV2Req) {
    pay_v2(req: $req) {
      entities {
        metadata {
          id
          short_name
          long_name
        }
        metrics {
          top_geos {
            index
            shortName
            longName
            base
            total
            hourly
          }
        }
      }
      refs {
        months
      }
    }
  }
`);
